function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.1055 15.2578C20.5156 14.7656 20.7891 14.1641 20.8438 13.4805C21.0352 11.4023 19.4219 9.625 17.3711 9.625H11.9297C11.6836 9.625 11.4922 9.84375 11.4922 10.0625V11.375C11.4922 11.6211 11.6836 11.8125 11.9297 11.8125H12.7773V19.6875H11.9297C11.6836 19.6875 11.4922 19.9062 11.4922 20.125V21.4375C11.4922 21.6836 11.6836 21.875 11.9297 21.875H17.6445C19.5859 21.875 21.3086 20.4805 21.5 18.5391C21.6367 17.2266 21.0352 16.0234 20.1055 15.2578ZM14.9648 11.8125H17.3711C18.082 11.8125 18.6836 12.4141 18.6836 13.125C18.6836 13.8633 18.082 14.4375 17.3711 14.4375H14.9648V11.8125ZM17.3711 19.6875H14.9648V16.625H17.3711C18.2188 16.625 18.9023 17.3359 18.9023 18.1562C18.9023 19.0039 18.2188 19.6875 17.3711 19.6875Z",
  fill: "#D5D7DE"
});

var SvgBold = function SvgBold(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBold, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bold.d84f0a4d.svg";
export { ForwardRef as ReactComponent };